export default __webpack_public_path__ + "static/media/icon-user-avatar.dc803468.svg";